import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import * as _ from 'lodash';
import { BaseModalPageComponent } from '../../base-modal.component';
import { AssociateEquipmentService } from './associateequipment-plugin.service';
import { Inspection } from '../../shared/models';

@Component({
    templateUrl: './associateequipment-select.component.html',
    standalone: false
})
export class AssociateEquipmentSelectComponent extends BaseModalPageComponent implements OnInit {
  selectedInspections: any[];
  inspections: any[];
  errorMessage: string;
  createProcessing = false;
  inspectionId: string;
  pluginId: string;
  orderByFieldName = 'order';
  direction = 'asc';

  public loading: Boolean = true;

  constructor(
    public service: AssociateEquipmentService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.router.navigate([this.inspectionsRoute]);
      }

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) {
        this.goToBack();
      }

      this.pluginId = pluginId;
      this.initData();
    });
  }

  selectInspection(inspection: any): void {
    inspection.selected = !inspection.selected;
    this.selectedInspections = _.filter(this.inspections, (s: any) => s.selected).sort((el) => el.order);
    this.cdRef.detectChanges();
  }

  addInspections(): void {
    this.createProcessing = true;
    this.resetSelectedInspections();
    this.service.addInspections(this.selectedInspections);
    this.goToBack();
  }

  cancel() {
    this.resetSelectedInspections();
    this.goToBack();
  }

  initData(): void {
    this.service.getInspections(this.inspectionId).subscribe((inspections) => {
      this.inspections = inspections;
      this.loading = false;
    });
  }

  resetSelectedInspections() {
    if (this.selectedInspections) {
      this.selectedInspections.forEach((s) => (s.selected = false));
    }
  }

  setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
